angular.module('dashboard').controller('MessagesDashboardCtrl',
    ['$scope', '$q', 'TransitionManager', 'MyMessagesService', 'MyChartService', 'DashboardService',
        function ($scope, $q, TransitionManager, MyMessagesService, MyChartService, DashboardService) {

            'use strict';

            $scope.loading = true;

            $scope.thumbnailSrc = MyChartService.getMaleThumbnailSrc(50,50);
            $scope.messages = null;
            $scope.myChart = {'Config': ''};


            function getMyChartConfig() {
                return MyChartService
                    .getMyChartConfig()
                    .then(function (config) {
                        $scope.myChart.Config = config;
                    });
            }

            function getNewMessages() {
                return MyMessagesService
                    .getNewMessages()
                    .then(function (data) {
                        $scope.messages = data;
                    });
            }

            $scope.load = function(tile) {
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                var messagesPromise = getNewMessages();
                var chartConfigPromise = getMyChartConfig();

                $q.all([messagesPromise, chartConfigPromise]).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }

            $scope.updateCollapseState = function updateCollapseState()
            {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };

            $scope.displayMessageThread = function displayMessageThread(message) {
                TransitionManager.transition({appRoute: 'myMessagesDisplayMessageThread', opts: {displayMode: 'received', id: message.MessageId, updateNotification: message.NewMessage}});
            };

        }
    ]
);